import {makeAutoObservable} from 'mobx'

export class MonthlyPaymentSummary {
  numericYear: number

  textYear: string

  month: number

  hebrewMonthName: string

  totalPaymentAmount: number

  institutionsCount: number

  totalStudentsCount: number

  constructor(monthlyPaymentSummary: any) {
    this.numericYear = monthlyPaymentSummary.NumericYear ?? monthlyPaymentSummary.Year
    this.textYear = monthlyPaymentSummary.TextYear ?? ''
    this.month = monthlyPaymentSummary.Month
    this.hebrewMonthName = monthlyPaymentSummary.HebrewMonthName ?? ''
    this.totalPaymentAmount = monthlyPaymentSummary.TotalPaymentAmount
    this.institutionsCount = monthlyPaymentSummary.InstitutionsCount
    this.totalStudentsCount = monthlyPaymentSummary.TotalStudentsCount

    makeAutoObservable(this)
  }
}
